import { TemplateTitle } from 'components/organisms/document/template-title';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const CompanyDocumumentTitle = ({ value, onChange }: Props) => {
  return <TemplateTitle value={value} onChange={onChange} />;
};
